import { render, staticRenderFns } from "./AppAccountQRcode.vue?vue&type=template&id=18ab6c63&scoped=true&lang=pug&"
import script from "./AppAccountQRcode.vue?vue&type=script&lang=ts&"
export * from "./AppAccountQRcode.vue?vue&type=script&lang=ts&"
import style0 from "./AppAccountQRcode.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppAccountQRcode.vue?vue&type=style&index=1&id=18ab6c63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab6c63",
  null
  
)

export default component.exports